// extracted by mini-css-extract-plugin
export default {"tabs":"style-module__tabs__AA0o8","list":"style-module__list__u0wAi"};